import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';

import { FaEye, FaEdit, FaTrash, FaCommentDots } from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import { STATUS_OPTIONS } from '../../Constant/leadConstent';
import LeadFilters from '../../common/leadFilter';
import Pagination from '../../common/Pagination';
import { TbFilterPause } from "react-icons/tb";
import Swal from "sweetalert2";
import { getAllLeadList, updateLeadStatus, deleteLead } from "../../redux/services/leadServices/Lead.Services"
function AllLeadLsit() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const role = localStorage.getItem("role");
    const isAdmin = role === "admin";
    const [leadData, setLeadData] = useState([]);
    const [initialLoading, setInitialLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(false);
    const [filteredLeads, setFilteredLeads] = useState([]);
    const [activeFilter, setActiveFilter] = useState("all");
    const [showRemarkPopup, setShowRemarkPopup] = useState(false);
    const [selectedRemark, setSelectedRemark] = useState("");
    const [showActions, setShowActions] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    const handleRemarkClick = (remark) => {
        setSelectedRemark(remark || "No Remark");
        setShowRemarkPopup(true);
    };
    const [counts, setCounts] = useState({
        all: 0,
        pending: 0,
        interested: 0,
        notInterested: 0,
        assign: 0
    });
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(100);
    const [totalLeads, setTotalLeads] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [showFilter, setShowFilter] = useState(false);
    const [filters, setFilters] = useState({
        status: "",
        source: "",
        customer_name: "",
        mobile: "",
        // search: "",
        from_date: "",
        to_date: ""
    });
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 1024;
            setIsMobile(mobile);
            if (!mobile) {
                setShowActions(false);
            }
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const handleDelete = async (id) => {
        try {
            const res = await deleteLead({
                id: id,
            });

            successToast(res?.message);
            const updatedLeads = leadData.filter(item => item.id !== id);
            setLeadData(updatedLeads);
            setFilteredLeads(updatedLeads);
            calculateCounts(updatedLeads, counts.all - 1);

        } catch (error) {
            errorToast(
                error?.response?.data?.message ||
                error?.message ||
                "Delete failed"
            );
        }
    };

    const handleStatusUpdate = async (data) => {
        try {
            await updateLeadStatus(data);

            Swal.fire({
                icon: "success",
                title: "Status Updated",
                text: "Lead status successfully updated!",
                timer: 1500,
                showConfirmButton: false
            });
            await fetchLeads(page);
            // fetchLeads();

        } catch (error) {
            console.log(error);
            errorToast("Status update failed");
        }
    };

    // useEffect(() => {
    //     fetchLeads();
    // }, []);
    // useEffect(() => {
    //     fetchLeads(1, "all");
    // }, []);
    useEffect(() => {
        fetchLeads(1, true);
    }, []);
    const fetchLeads = async (pageNo = 1, initialLoad = false, currentLimit = limit) => {
        try {
            // setLoading(true);
            // const payload = {
            //     page: pageNo,
            //     per_page: limit,
            // };
            if (initialLoad) {
                setInitialLoading(true);
            } else {
                setTableLoading(true);
            }
            const payload = {
                page: pageNo,
                per_page: limit,
                ...(filters.status && { status: filters.status }),
                ...(filters.source && { source: filters.source }),
                ...(filters.customer_name && { customer_name: filters.customer_name }),
                ...(filters.mobile && { mobile: filters.mobile }),
                ...(filters.from_date && { from_date: filters.from_date }),
                ...(filters.to_date && { to_date: filters.to_date }),
            };

            const response = await getAllLeadList(payload);
            const leads = response?.data || [];
            const total = response?.total || 0;
            calculateCounts(leads);
            filterLeads(leads, "all");
            setLeadData(leads);
            setLeadData(response?.data || []);
            setFilteredLeads(leads);
            setPage(response?.current_page || 1);
            setTotalPages(response?.last_page || 1);
            setTotalLeads(response?.total || 0);
            setCounts((prev) => ({
                ...prev,
                all: total
            }));
        } catch (error) {
            console.log(error);
            errorToast("Failed to fetch leads");
        } finally {
            setInitialLoading(false);
            setTableLoading(false);
        }
    };
    // const handlePageChange = (newPage) => {
    //     setPage(newPage);
    //     fetchLeads(newPage);
    // };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
            fetchLeads(newPage, false);
        }
    };
    const calculateCounts = (leads, total) => {
        // const pendingCount = leads.filter(lead => lead.status === "pending" || lead.status === "Pending").length;
        const interestedCount = leads.filter(lead => lead.status === "interested" || lead.status === "Interested").length;
        const notInterestedCount = leads.filter(lead => lead.status === "not interested" || lead.status === "Not Interested").length;
        const assignedCount = leads.filter(
            lead => lead.assign_to && lead.assign_to !== null
        ).length;
        setCounts({
            all: total,
            // pending: pendingCount,
            interested: interestedCount,
            notInterested: notInterestedCount,
            assign: assignedCount
        });
    };

    const filterLeads = (leads, filterType) => {
        let filtered = [];
        switch (filterType) {
            case "pending":
                filtered = leads.filter(lead => lead.status === "pending" || lead.status === "Pending");
                break;
            case "interested":
                filtered = leads.filter(lead => lead.status === "interested" || lead.status === "Interested");
                break;
            case "notInterested":
                filtered = leads.filter(lead => lead.status === "not interested" || lead.status === "Not Interested");
                break;
            case "assigned":
                filtered = leads.filter(l => l.assign_to && l.assign_to !== null);
                break;
            default:
                filtered = leads;
        }
        setFilteredLeads(filtered);
    };

    const handleFilterClick = (filterType) => {
        setActiveFilter(filterType);
        // filterLeads(leadData, filterType);
        setPage(1);
        fetchLeads(1, filterType);
    };

    const tabs = [
        { label: `All Leads (${counts.all || 0})`, className: "btn-all", value: "all" },
        // { label: `Pending Leads (${counts.pending || 0})`, className: "btn-warning", value: "pending" },
        { label: `Interested Leads (${counts.interested || 0})`, className: "btn-interested", value: "interested" },
        // { label: `Assigned Leads (${counts.assign || 0})`, className: "btn-info", value: "assigned" },
        { label: `Not Interested (${counts.notInterested || 0})`, className: "btn-not-interested", value: "notInterested" },

        ...(isAdmin
            ? [
                {
                    label: `Assigned Leads (${counts.assign || 0})`,
                    className: "btn-assigned",
                    value: "assigned",
                },
            ]
            : []),

    ];

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleApplyFilters = () => {
        let filtered = [...leadData];

        // Status filter
        if (filters.status) {
            filtered = filtered.filter(lead => lead.status === filters.status);
        }

        // Source filter
        if (filters.source) {
            filtered = filtered.filter(lead => lead.source === filters.source);
        }

        // Customer name filter
        if (filters.customer_name) {
            filtered = filtered.filter(lead =>
                lead.name?.toLowerCase().includes(filters.customer_name.toLowerCase())
            );
        }

        // Mobile filter
        if (filters.mobile) {
            filtered = filtered.filter(lead =>
                lead.mobile?.includes(filters.mobile)
            );
        }

        // Search filter
        // if (filters.search) {
        //     filtered = filtered.filter(lead =>
        //         lead.name?.toLowerCase().includes(filters.search.toLowerCase()) ||
        //         lead.email?.toLowerCase().includes(filters.search.toLowerCase()) ||
        //         lead.mobile?.includes(filters.search)
        //     );
        // }

        // From date filter
        if (filters.from_date) {
            filtered = filtered.filter(lead =>
                new Date(lead.created_at) >= new Date(filters.from_date)
            );
        }

        // To date filter
        if (filters.to_date) {
            filtered = filtered.filter(lead =>
                new Date(lead.created_at) <= new Date(filters.to_date)
            );
        }

        setFilteredLeads(filtered);
        // setShowFilter(false);
        successToast("Filters applied successfully!");
    };

    const handleResetFilters = () => {
        setFilters({
            status: "",
            source: "",
            customer_name: "",
            mobile: "",
            // search: "",
            from_date: "",
            to_date: ""
        });
        setFilteredLeads(leadData);
        setActiveFilter("all");
        successToast("Filters reset successfully!");
    };

    const handleToggleFilter = () => {
        setShowFilter(!showFilter);
    };
    if (initialLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }



    return (
        <div>
            {/* <div className="pageheaderall position-relative d-md-flex align-items-center justify-content-between page-header-breadcrumb">                <div className="ms-md-1 mb-2 mb-md-0">
                <h4 className="fw-semibold mb-0">All Lead List</h4>
                <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">All Leads</li>
                </ol>
            </div>

                <div className="d-flex flex-column gap-2 align-items-end">
                    <div className="d-flex flex-wrap gap-2 justify-content-end">
                        {tabs.map((tab, index) => (
                            <button
                                key={index}
                                className={`lead-btn btn-all ${tab.className} ${activeFilter === tab.value ? "active" : ""
                                    }`}
                                onClick={() => handleFilterClick(tab.value)}
                            >
                                {tab.label}
                            </button>
                        ))}
                        <button
                            className="lead-btn btn-filter"
                            onClick={handleToggleFilter}
                        >
                            <i className="fas fa-filter me-1"></i>
                            {showFilter ? "Hide Filter" : "Filter"}
                        </button>

                        {role === "admin" && (
                            <>
                                <button
                                    onClick={() => navigate("/add-lead")}
                                    className="lead-btn btn-add"
                                >
                                    Add Lead
                                </button>

                                <button
                                    className="lead-btn btn-import"
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                type: "import-lead",
                                                title: "Import Leads",
                                                data: null,
                                            })
                                        )
                                    }
                                >
                                    Import Lead
                                </button>
                            </>
                        )}
                    </div>



                </div>
            </div> */}

            <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
                <div className="title_member">
                    <h4>All Lead List</h4>
                    <nav className="page-breadcrumb">
                        <Link to="/">Home</Link>
                        <span className="mx-2">/</span>
                        <span>All Leads</span>
                    </nav>
                </div>

                    {isMobile && (
                        <button
                            className="btn btn-primary"
                            onClick={() => setShowActions(!showActions)}
                        >
                            {showActions ? <TbFilterPause /> : <TbFilterPause />}
                        </button>
                    )}
          

                {/* Desktop Buttons */}
                {!isMobile && (
                    <div className="d-flex align-items-center  gap-2 justify-content-end">
                        {tabs.map((tab, index) => (
                            <button
                                key={index}
                                className={`lead-btn btn-all ${tab.className} ${activeFilter === tab.value ? "active" : ""
                                    }`}
                                onClick={() => handleFilterClick(tab.value)}
                            >
                                {tab.label}
                            </button>
                        ))}

                        <button
                            className="lead-btn btn-filter"
                            onClick={handleToggleFilter}
                        >
                            <i className="fas fa-filter me-1"></i>
                            {showFilter ? "Hide Filter" : "Filter"}
                        </button>

                        {role === "admin" && (
                            <>
                                <button
                                    className="lead-btn btn-add"
                                    onClick={() => navigate("/add-lead")}
                                >
                                    Add Lead
                                </button>

                                <button
                                    className="lead-btn btn-import"
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                type: "import-lead",
                                                title: "Import Leads",
                                                data: null,
                                            })
                                        )
                                    }
                                >
                                    Import Lead
                                </button>
                            </>
                        )}
                    </div>
                )}
            </div>
            {/* Mobile Bottom Sheet */}
            {isMobile && (
                <>
                    {/* Overlay */}
                    <div
                        className={`menu-overlay ${showActions ? "show" : ""
                            }`}
                        onClick={() => setShowActions(false)}
                    ></div>

                    <div
                        className={`dorpdownloaddatabutton ${showActions ? "active" : ""
                            }`}
                    >
                        {tabs.map((tab, index) => (
                            <button
                                key={index}
                                className={`lead-btn btn-all ${tab.className} ${activeFilter === tab.value ? "active" : ""
                                    }`}
                                onClick={() => {
                                    handleFilterClick(tab.value);
                                    setShowActions(false);
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}

                        <button
                            className="lead-btn btn-filter"
                            onClick={() => {
                                handleToggleFilter();
                                setShowActions(false);
                            }}
                        >
                            <i className="fas fa-filter me-1"></i>
                            {showFilter ? "Hide Filter" : "Filter"}
                        </button>

                        {role === "admin" && (
                            <>
                                <button
                                    className="lead-btn btn-add"
                                    onClick={() => {
                                        navigate("/add-lead");
                                        setShowActions(false);
                                    }}
                                >
                                    Add Lead
                                </button>

                                <button
                                    className="lead-btn btn-import"
                                    onClick={() => {
                                        dispatch(
                                            openModal({
                                                type: "import-lead",
                                                title: "Import Leads",
                                                data: null,
                                            })
                                        );
                                        setShowActions(false);
                                    }}
                                >
                                    Import Lead
                                </button>
                            </>
                        )}
                    </div>
                </>
            )}

            <LeadFilters
                showFilter={showFilter}
                filters={filters}
                filteredStatusOptions={STATUS_OPTIONS}
                onFilterChange={handleFilterChange}
                onApplyFilters={handleApplyFilters}
                onResetFilters={handleResetFilters}
                onToggleFilter={handleToggleFilter}
            />




          <div className='main_page'>
  {totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center flex-wrap">


                    {/* <div className="d-flex align-items-center">
                    <label className="mb-0">Show</label>
                    <select
                        className="form-select form-select-sm"
                        // style={{ width: "90px" }}
                        value={limit}
                        onChange={(e) => {
                            const newLimit = Number(e.target.value);
                            setLimit(newLimit);
                            setPage(1);
                          fetchLeads(1, false, newLimit);
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div> */}


                    <div className="col-12 d-flex justify-content-end">

                        <Pagination
                            page={page}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>


                </div>
            )}

            <div className="st-wrapper-card">

                <div className="st-table-responsive">

                    <table className="table st-custom-table align-middle mb-0">

                        <thead>

                            <tr>
                                <th>Sr.No.</th>
                                <th>Lead Id</th>
                                <th> Name</th>
                                <th> Mobile No</th>
                                <th> Source</th>
                                {/* <th> Assigned By</th>
                                {role === "admin" && <th>Assigned To</th>} */}
                                {/* <th>Assigned Info</th> */}
                                {/* <th>Status</th> */}
                                <th>Remark</th>
                                <th className="text-center">
                                    Action
                                </th>
                            </tr>

                        </thead>

                        <tbody>
                            {tableLoading ? (
                                <tr>
                                    <td colSpan="7" className="text-center py-5">
                                        <div className="spinner-border text-primary"></div>
                                    </td>
                                </tr>
                            ) : (

                                filteredLeads?.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{(page - 1) * limit + index + 1}</td>

                                        <td>{item.lead_id}</td>
                                        <td className="fw-semibold"> {item?.name} </td>
                                        <td>{item.mobile}</td>
                                        <td>{item.source}</td>
                                        {/* <td>{item.assign_by?.name}</td>
                                        {role === "admin" && (
                                            <td>{item.assign_to?.name}</td>
                                        )} */}
                                        {/* <td>
                                            <div className="d-flex align-items-center gap-2">
                                                <span className="whitedesign text-primary fw-semibold">
                                                    By: {item.assign_by?.name || "-"}
                                                </span>

                                                <span>|</span>

                                                <span className="whitedesign text-success fw-semibold">
                                                    To: {item.assign_to?.name || "-"}
                                                </span>
                                            </div>
                                        </td> */}
                                        {/* <td className="fw-semibold">
                                            {
                                                item.status
                                            }
                                        </td> */}
                                        {/* <td>
                                            <div className="remark-cell">
                                                {item.remarks}
                                            </div>
                                        </td> */}
                                        <td>
                                            <div
                                                className="remark-cell text-primary"
                                                style={{
                                                    cursor: "pointer",
                                                    maxWidth: "150px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap"
                                                }}
                                                onClick={() => handleRemarkClick(item.remarks)}
                                            >
                                                {item.remarks || "View Remark"}
                                            </div>
                                        </td>
                                        {/* <td style={{ width: "150px" }}>
                                            <div className="city-status-switch">
                                                <input
                                                    type="checkbox"
                                                    id={`status-${item._id || item.id}`}
                                                    className="city-status-input"
                                                    checked={item.status === 'true' || item.status === 1}
                                                    readOnly
                                                />
                                                <label
                                                    htmlFor={`status-${item._id || item.id}`}
                                                    className="city-status-label"
                                                >
                                                    <span className="city-status-ball"></span>

                                                    <span className="city-status-text">
                                                        {
                                                            (item.status === 'true' || item.status === 1)
                                                                ? 'Active'
                                                                : 'Inactive'
                                                        }
                                                    </span>
                                                </label>
                                            </div>
                                        </td> */}

                                        {/* <td style={{ minWidth: "160px" }}>
                                            {isAdmin ? (
                                                <select
                                                    value={item.status || "-"}
                                                    onChange={(e) =>
                                                        dispatch(
                                                            openModal({
                                                                type: "update-status",
                                                                title: "Update Lead Status",
                                                                data: {
                                                                    id: item.id,
                                                                    status: e.target.value,
                                                                    statusOptions: STATUS_OPTIONS,
                                                                    role,
                                                                    onSubmit: handleStatusUpdate,
                                                                },
                                                            })
                                                        )
                                                    }
                                                >
                                                    {STATUS_OPTIONS.map((opt) => (
                                                        <option key={opt.value} value={opt.value}>
                                                            {opt.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <select disabled value={item.status || "-"}>
                                                    {STATUS_OPTIONS.map((opt) => (
                                                        <option key={opt.value} value={opt.value}>
                                                            {opt.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}


                                        </td> */}

                                        <td className="text-center">

                                            <div className="d-flex align-items-center justify-content-center gap-1">
                                                <button
                                                    className="st-action-btn st-view-btn"

                                                    onClick={() => navigate(`/view-lead/${item.id}`)}
                                                >
                                                    <FaEye />
                                                </button>
                                                {/*  <button
                                                className="st-action-btn st-edit-btn"
                                          
                                                onClick={() => navigate(`/update-lead/${item.id}`)}
                                            >
                                                <FaEdit />
                                            </button> */}


                                                {/* <button
                                                className="st-action-btn st-edit-btn"
                                                onClick={() => {
                                                    if (isAdmin) {
                                                        // 👑 ADMIN → PAGE OPEN
                                                        navigate(`/update-lead/${item.id}`);
                                                    } 
                                                    else {

                                                        dispatch(
                                                            openModal({
                                                                type: "update-status",
                                                                title: "Update Lead Status",
                                                                data: {
                                                                    id: item.id,
                                                                    status: item.status,
                                                                    statusOptions: STATUS_OPTIONS,
                                                                    role,
                                                                    onSubmit: updateLeadStatus,
                                                                },
                                                            })
                                                        );
                                                    }
                                                }}
                                            >
                                                <FaEdit />
                                            </button> */}


                                                {isAdmin && (
                                                    <button
                                                        className="st-action-btn st-edit-btn"
                                                        onClick={() => {
                                                            dispatch(
                                                                openModal({
                                                                    type: "update-status",
                                                                    title: "Update Lead Status",
                                                                    data: {
                                                                        id: item.id,
                                                                        status: item.status,
                                                                        statusOptions: STATUS_OPTIONS,
                                                                        role,
                                                                        onSubmit: updateLeadStatus,
                                                                        onSuccess: () => {
                                                                            fetchLeads();
                                                                        },
                                                                    },
                                                                })
                                                            );
                                                        }}
                                                    >
                                                        <FaEdit />
                                                    </button>
                                                )}
                                                {role === "admin" && (
                                                    <button
                                                        className="st-action-btn st-delete-btn"
                                                        // onClick={() => handleDelete(item.id)}
                                                        onClick={() =>
                                                            dispatch(
                                                                openModal({
                                                                    type: "delete-lead",
                                                                    title: "Delete Lead",
                                                                    data: {
                                                                        id: item.id,
                                                                        deleteFunction: deleteLead,
                                                                        refreshData: () => fetchLeads(page),
                                                                    },
                                                                })
                                                            )
                                                        }
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                )}
                                                <button
                                                    className="st-action-btn st-view-btn"
                                                    // onClick={() =>
                                                    //     handleDelete(item._id)
                                                    // }
                                                    onClick={() => navigate(`/remark-history/${item.id}`)}
                                                >
                                                    < FaCommentDots />

                                                </button>


                                            </div>

                                        </td>

                                    </tr>

                                ))
                            )}

                        </tbody>
                    </table>
                    {totalPages > 1 && (
                        <Pagination
                            page={page}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}
                </div>

            </div>
            {showRemarkPopup && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)"
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Remark Details
                                </h5>

                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowRemarkPopup(false)}
                                ></button>
                            </div>

                            <div className="modal-body">
                                <p style={{ whiteSpace: "pre-wrap" }}>
                                    {selectedRemark}
                                </p>
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowRemarkPopup(false)}
                                >
                                    Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
          </div>
        </div>


    );
}

export default AllLeadLsit;